import { MenuItem, Select, SelectChangeEvent } from "@mui/material";
import { PlayerInfo } from "src/components/implementationTypes";

type PlayerSelectorProps = {
  canSelectColor: boolean;
  playAsColor: string;
  players: PlayerInfo[] | undefined;
  changeCurrentPlayer: (newColor: string) => void;
};
export function PlayerSelector({ canSelectColor, playAsColor, players, changeCurrentPlayer }: PlayerSelectorProps) {
  if (!canSelectColor) {
    return <div>You are playing as {playAsColor}</div>;
  }

  function handleSelectedPlayerChange(evt: SelectChangeEvent) {
    changeCurrentPlayer(evt.target.value);
  }

  const options: JSX.Element[] = [];
  if (players) {
    for (let player of players) {
      if (player.isAutoma) {
        continue;
      }
      if (player.color === playAsColor) {
        options.push(
          <MenuItem key={player.color} value={player.color} selected>
            {player.color}
          </MenuItem>,
        );
      } else {
        options.push(
          <MenuItem key={player.color} value={player.color}>
            {player.color}
          </MenuItem>,
        );
      }
    }
  }
  options.push(
    <MenuItem key={"disabled"} disabled>
      ---
    </MenuItem>,
  );
  options.push(
    <MenuItem key={"alwaysactive"} value="alwaysactive">
      Always active
    </MenuItem>,
  );
  options.push(
    <MenuItem key={"spectator"} value="spectator" selected={"spectator" === playAsColor ? true : false}>
      Spectator
    </MenuItem>,
  );

  return (
    <Select id="player-select" onChange={handleSelectedPlayerChange} value={playAsColor} fullWidth margin="dense">
      {options}
    </Select>
  );
}
